import DepositIcon from "@/components/icons/deposit-icon";
import WithdrawIcon from "@/components/icons/withdraw-icon";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";

const SuccessNotice = ({
  type,
  closeModal,
}: {
  type:
    | "withdrawal"
    | "deposit"
    | "card-topup"
    | "card-withdrawal"
    | "add-contact"
    | "register";

  closeModal: () => void;
}) => {
  if (type === "deposit")
    return (
      <div className="my-4 flex w-full flex-col items-center gap-4">
        <div
          className="border-primary-100 flex size-16 items-center justify-center rounded-full border"
          style={{
            background:
              "linear-gradient(100.47deg, #5778C766 9.36%, #545A9366 100%)",
          }}
        >
          <DepositIcon className="text-primary-100" />
        </div>
        <div className="mt-2 text-2xl font-medium">Deposit successful</div>
        <div className="mt-4 flex w-full items-center gap-2">
          <Button
            onClick={closeModal}
            className="text-primary-500 bg-primary-100 hover:bg-primary-100-hover h-11 grow"
          >
            Continue
          </Button>
          <Button
            onClick={closeModal}
            className="hover:text-primary-500 border-primary-100 hover:bg-primary-100 h-11 grow border bg-transparent text-white"
          >
            See Details
          </Button>
        </div>
      </div>
    );

  if (type === "withdrawal")
    return (
      <div className="my-4 flex w-full flex-col items-center gap-4">
        <div
          className="border-primary-100 flex size-16 items-center justify-center rounded-full border"
          style={{
            background:
              "linear-gradient(100.47deg, #5778C766 9.36%, #545A9366 100%)",
          }}
        >
          <WithdrawIcon className="text-primary-100" />
        </div>
        <div className="mt-2 text-2xl font-medium">Withdrawal successful</div>
        <div className="mt-4 flex w-full items-center gap-2">
          <Button
            onClick={closeModal}
            className="text-primary-500 bg-primary-100 hover:bg-primary-100-hover h-11 grow"
          >
            Continue
          </Button>
          <Button
            onClick={closeModal}
            className="hover:text-primary-500 border-primary-100 hover:bg-primary-100 h-11 grow border bg-transparent text-white"
          >
            See Details
          </Button>
        </div>
      </div>
    );

  if (type === "card-topup")
    return (
      <div className="my-4 flex w-full flex-col items-center gap-4">
        <div
          className="border-primary-100 flex size-16 items-center justify-center rounded-full border"
          style={{
            background:
              "linear-gradient(100.47deg, #5778C766 9.36%, #545A9366 100%)",
          }}
        >
          <DepositIcon className="text-primary-100" />
        </div>
        <div className="mt-2 text-2xl font-medium">Card Top Up successful</div>
        <div className="mt-4 flex w-full items-center gap-2">
          <Button
            onClick={closeModal}
            className="text-primary-500 bg-primary-100 hover:bg-primary-100-hover h-11 grow"
          >
            Continue
          </Button>
          <Button
            onClick={closeModal}
            className="hover:text-primary-500 border-primary-100 hover:bg-primary-100 h-11 grow border bg-transparent text-white"
          >
            See Details
          </Button>
        </div>
      </div>
    );

  if (type === "card-withdrawal")
    return (
      <div className="my-4 flex w-full flex-col items-center gap-4">
        <div
          className="border-primary-100 flex size-16 items-center justify-center rounded-full border"
          style={{
            background:
              "linear-gradient(100.47deg, #5778C766 9.36%, #545A9366 100%)",
          }}
        >
          <WithdrawIcon className="text-primary-100" />
        </div>
        <div className="mt-2 text-2xl font-medium">
          Card Withdrawal successful
        </div>
        <div className="mt-4 flex w-full items-center gap-2">
          <Button
            onClick={closeModal}
            className="text-primary-500 bg-primary-100 hover:bg-primary-100-hover h-11 grow"
          >
            Continue
          </Button>
          <Button
            onClick={closeModal}
            className="hover:text-primary-500 border-primary-100 hover:bg-primary-100 h-11 grow border bg-transparent text-white"
          >
            See Details
          </Button>
        </div>
      </div>
    );

  if (type === "add-contact")
    return (
      <div className="my-4 flex w-full flex-col items-center gap-4">
        <div
          className="border-primary-100 flex size-16 items-center justify-center rounded-full border"
          style={{
            background:
              "linear-gradient(100.47deg, #5778C766 9.36%, #545A9366 100%)",
          }}
        >
          <Check className="text-primary-100" />
        </div>
        <div className="mt-2 text-2xl font-medium">
          Contact added successfully
        </div>
        <div className="mt-4 flex w-full items-center gap-2">
          <Button
            onClick={closeModal}
            className="text-primary-500 bg-primary-100 hover:bg-primary-100-hover h-11 grow"
          >
            Close
          </Button>
        </div>
      </div>
    );

  if (type === "register")
    return (
      <div className="my-4 flex w-full flex-col items-center gap-4">
        <div
          className="border-primary-100 flex size-16 items-center justify-center rounded-full border"
          style={{
            background:
              "linear-gradient(100.47deg, #5778C766 9.36%, #545A9366 100%)",
          }}
        >
          <Check className="text-primary-100" />
        </div>
        <div className="mt-2 text-2xl font-medium">
          Account created successfully
        </div>
        <div className="mt-4 flex w-full items-center gap-2">
          <Button
            onClick={() => (window.location.href = "/login")}
            className="text-primary-500 bg-primary-100 hover:bg-primary-100-hover h-11 grow"
          >
            Continue to Login
          </Button>
        </div>
      </div>
    );
};

export default SuccessNotice;
